import { Nav } from '@accedo/spatial-nav';
import { FunctionComponent } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { Dispatch } from 'preact/compat';
import { stylesheet } from 'astroturf';
import clsx from 'clsx';
import AppButton10Play from '##/assets/icons/10-rebrand-logo.png';

const styles = stylesheet`
  @import '##/styles/import.scss';

  @keyframes flash {
    0% {
      opacity: 0.3;
    }

    50% {
      opacity: 1;
    }

    100% {
      opacity: 0.3;
    }
  }

  .container {
    @include dimensions();

    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $app-background-colour;
  }

  .loading-logo {
    height: 20vh;
    display: block;
    margin: 40vh auto;
    animation: flash 1.5s ease infinite;
  }
`;

type LoadingIndicatorProps = {
  customId?: string;
  showOnMount?: boolean;
};

// eslint-disable-next-line import/no-mutable-exports
export let setLoadingIndicatorVisibility: Dispatch<boolean> | null;

export const LoadingIndicator: FunctionComponent<LoadingIndicatorProps> = ({
  customId = '',
  showOnMount = true,
}) => {
  const [show, setShow] = useState(showOnMount);

  useEffect(() => {
    setLoadingIndicatorVisibility = setShow;

    return () => {
      setLoadingIndicatorVisibility = null;
    };
  }, []);

  return show ? (
    <Nav.Focusable id={customId || 'loading-indicator-focus'}>
      <div className={clsx(styles.container, 'z8')}>
        <img
          src={AppButton10Play}
          className={styles.loadingLogo}
          alt="loading"
        />{' '}
      </div>
    </Nav.Focusable>
  ) : null;
};
